export function concatenarArray(valores, separador) {
  const lista = Array.isArray(valores) ? valores : [valores]
  const sep = separador == null ? '' : String(separador)
  return lista.filter((v) => v != null && v !== '').map(String).join(sep)
}
